import { FieldValidatorType } from "@progress/kendo-react-form";
import { LocalizationService } from "@progress/kendo-react-intl";
import { enMessages } from "../../../messages/en-US";
import { SiteReadDto } from "../../../Models/Site/SiteReadDto";

interface NameValidatorParams {
  existingSites?: SiteReadDto[];
  currentSite?: SiteReadDto | null;
  localizationService: LocalizationService;
}

interface DescriptionValidatorParams {
  localizationService: LocalizationService;
}

interface TimezoneValidatorParams {
  localizationService: LocalizationService;
}

export const nameValidator = ({
  existingSites,
  currentSite,
  localizationService
}: NameValidatorParams): FieldValidatorType => (value: any, valueGetter?: (name: string) => any, fieldProps?: { name: string }) => {
  // Check if empty
  if (!value || value.trim() === "") {
    return localizationService.toLanguageString("custom.fieldIsRequired", enMessages.custom.fieldIsRequired);
  }
  
  // Check minimum length (2 characters)
  if (value.trim().length < 2) {
    return localizationService.toLanguageString("custom.nameMinLength", (enMessages.custom as any).nameMinLength || "Name must be at least 2 characters");
  }
  
  // Check for duplicates (case-insensitive, excluding current site if editing)
  if (existingSites) {
    const trimmedValue = value.trim();
    const duplicateSite = existingSites.find(
      (site) => site.id !== currentSite?.id && site.name.toLowerCase() === trimmedValue.toLowerCase()
    );
    if (duplicateSite) {
      return localizationService.toLanguageString("custom.nameExists", (enMessages.custom as any).nameExists || "This name already exists. Please choose a different name.");
    }
  }
  
  return "";
};

export const descriptionValidator = ({
  localizationService
}: DescriptionValidatorParams): FieldValidatorType => (value: any, valueGetter?: (name: string) => any, fieldProps?: { name: string }) => {
  // Check if empty
  if (!value || value.trim() === "") {
    return localizationService.toLanguageString("custom.fieldIsRequired", enMessages.custom.fieldIsRequired);
  }
  
  // Check minimum length (2 characters)
  if (value.trim().length < 2) {
    return localizationService.toLanguageString("custom.descriptionMinLength", (enMessages.custom as any).descriptionMinLength || "Description must be at least 2 characters");
  }
  
  return "";
};

export const timezoneValidator = ({
  localizationService
}: TimezoneValidatorParams): FieldValidatorType => (value: any, valueGetter?: (name: string) => any, fieldProps?: { name: string }) => {
  if (!value || !value.value) {
    return localizationService.toLanguageString("custom.fieldIsRequired", enMessages.custom.fieldIsRequired);
  }
  return "";
};
